import * as React from 'react';

var ImageContext = React.createContext({ size: 'extraLarge' });
var sizeConfig = {
    extraLarge: {
        extraLargeImageWidth: 3780,
        extraSmallImageWidth: 960,
        largeImageWidth: 3060,
        mediumImageWidth: 2160,
        smallImageWidth: 1125,
        smallReducedGutterImageWidth: 1080,
    },
    large: {
        extraLargeImageWidth: 2520,
        extraSmallImageWidth: 640,
        largeImageWidth: 1040,
        mediumImageWidth: 1440,
        smallImageWidth: 750,
        smallReducedGutterImageWidth: 720,
    },
    medium: {
        extraLargeImageWidth: 1260,
        extraSmallImageWidth: 320,
        largeImageWidth: 1020,
        mediumImageWidth: 720,
        smallImageWidth: 375,
        smallReducedGutterImageWidth: 360,
    },
    small: {
        extraLargeImageWidth: 1260,
        extraSmallImageWidth: 359,
        largeImageWidth: 1260,
        mediumImageWidth: 1020,
        smallImageWidth: 720,
        smallReducedGutterImageWidth: 375,
    },
};

export { ImageContext, sizeConfig };
//# sourceMappingURL=ImageContext.esm.js.map
